import { TextBody } from '@zappyrent/hundop';
import React from 'react';

import {
  StyledH3,
  StyledLink,
  StyledSubtitle,
} from '../TextPageLandlord/TextPageLandlord.styles';

const AffittaCasa = (): JSX.Element => {
  return (
    <>
      <StyledH3 sm="24px" md="24px" lg="24px" tag="h3">
        Affitta casa, appartamenti o stanze!
      </StyledH3>
      <TextBody>
        L’intento con cui abbiamo creato il sito di affitti online Zappyrent era
        quello di stabilire una connessione diretta tra chi ha un immobile di
        proprietà da affittare e chi ha l’esigenza di trovare un appartamento o
        una stanza da prendere in locazione.{' '}
        <strong>Abbiamo realizzato,</strong> per questo scopo,{' '}
        <strong>uno strumento versatile e semplice da utilizzare</strong> che
        potesse anche essere accessibile a tutti, privo dei costi
        tradizionalmente presenti nel campo dell’intermediazione immobiliare.
      </TextBody>
      <TextBody>
        Ma non solo: per lasciare libere le parti di concentrarsi solo sugli
        aspetti sostanziali dell’accordo, abbiamo organizzato un sistema per cui{' '}
        <strong>
          siamo noi ad occuparci direttamente e in modo esclusivo della gestione
          degli aspetti economici
        </strong>{' '}
        del rapporto.
      </TextBody>
      <TextBody>
        Con queste motivazioni, abbiamo dato vita ad una realtà che raggiunge i
        suoi obiettivi operando online, proponendosi di{' '}
        <strong>
          rendere l’esperienza dell’affitto tra privati quanto più semplice
          possibile
        </strong>{' '}
        e, al tempo stesso, permettendo al proprietario di scoprire come
        affittare casa senza rischi e in maniera remunerativa.
      </TextBody>
      <StyledSubtitle tag="strong">
        Trattative semplificate per i tuoi affari
      </StyledSubtitle>
      <TextBody>
        Sappiamo bene quante complicazioni possono insorgere durante il processo
        di locazione di un immobile e quali conflitti possono crearsi nella
        gestione dei rapporti con l’inquilino.{' '}
        <strong>
          Consentire ai nostri clienti di sperimentare l’esperienza di affittare
          casa online
        </strong>{' '}
        e di sapere come affittare casa velocemente e in sicurezza,{' '}
        <strong>è la nostra missione:</strong> per questo, i nostri protocolli
        non prevedono alcuna intermediazione, né costi aggiuntivi o imprevisti.
      </TextBody>
      <TextBody>
        Se sei proprietario di un appartamento e vuoi darlo in locazione,
        affidando il tuo immobile a Zappyrent,{' '}
        <strong>
          proverai la soddisfazione di concludere un contratto di affitto
          proficuo e tutelato,
        </strong>{' '}
        semplicemente attraverso la pubblicazione di un annuncio online.{' '}
        <strong>Noi ti consentiamo,</strong>
        infatti, di <strong>
          inserire annunci di affitto casa gratis,
        </strong>{' '}
        integrandoli con tutte le informazioni utili a renderli quanto più
        possibile completi ed esaurienti.
      </TextBody>
      <TextBody>
        Potrai descrivere i dettagli dell’abitazione e fissare le condizioni per
        la conclusione del contratto: non appena riceverai una proposta, la
        valuterai e deciderai in piena autonomia se accettarla o fare una
        controproposta al potenziale inquilino, indicando il prezzo che desideri
        ricevere a titolo di canone mensile per l’affitto del tuo appartamento
        o, se preferisci, della singola stanza. Se l’inquilino accetta la tua
        controproposta, la prenotazione è automaticamente accettata. Rapidamente
        e senza complicazioni.
      </TextBody>
      <StyledSubtitle tag="strong">
        Protezione Zappyrent: pagamenti sicuri
      </StyledSubtitle>
      <TextBody>
        I contratti stipulati con Zappyrent, non prevedono solo trattative
        semplificate, condotte direttamente dalle parti interessate;
        successivamente al perfezionamento dell’accordo,{' '}
        <strong>
          il sistema che regola i pagamenti delle mensilità è estremamente agile
          e interamente gestito da noi.
        </strong>{' '}
        Inoltre, grazie alla nostra{' '}
        <StyledLink
          href={`${process.env.GATSBY_SITE_URL}/it/protezione-zappyrent`}
        >
          formula di protezione sugli affitti Protezione Zappyrent
        </StyledLink>
        , il locatore non avrà più la preoccupazione di imbattersi in ritardi
        nei pagamenti o, peggio, in questioni di morosità.
      </TextBody>
      <TextBody>
        L’attività che svolgiamo su{' '}
        <strong>
          Zappyrent non ha i costi elevati previsti dalle agenzie immobiliari
        </strong>{' '}
        e la nostra policy di sicurezza prevede che, entro 48 ore dal check-in
        del locatario nell’alloggio, l’importo corrispondente alla prima
        mensilità di canone ti venga direttamente accreditato sul conto che tu
        stesso hai indicato all’atto della registrazione.
      </TextBody>
      <TextBody>
        Il deposito cauzionale, nell’ammontare determinato da te e versato
        dall’inquilino, verrà congelato sul conto di quest’ultimo e reso
        disponibile per coprire i danni risarcibili eventualmente causati
        all’immobile di tua proprietà.
      </TextBody>
    </>
  );
};

export default AffittaCasa;
